var _defs, _text, _path, _polygon, _polygon2, _polygon3, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-46 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-family:Poppins-Bold, Poppins;font-size:28.24px;font-weight:700;letter-spacing:.1em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(138.73 193.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SandboxNB"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.62,120.88v79.75c-14.85-7.72-31.34-11.74-48.13-11.72v-42.97l6.05-3.15v14.75l7.29-2.29v-16.26l8.95-4.66v18.11l11.26-3.53v-20.44l14.58-7.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "101.45 134.34 101.45 152.45 90.19 148.91 90.19 140.2 101.45 134.34"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.69 142.8 117.69 157.55 110.4 155.26 110.4 146.6 117.69 142.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.4 171.66 110.4 204.45 101.45 201.66 101.45 172.6 110.4 171.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.19,236.11c-2.29.9-4.53,1.9-6.72,3-15.38-16.8-36.57-26.52-59.98-26.58v-7.08c25.53-.13,50.29,11.44,66.7,30.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.63,222.45c-2.54.74-5.04,1.6-7.52,2.56-16.86-15.54-39.69-24.38-62.62-24.28v-7.08c26.1-.11,51.7,10.45,70.14,28.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.75,223.45v7.08c-8.46,0-16.71,1.29-24.7,3.85-1.63-1.97-3.35-3.88-5.16-5.72,9.53-3.45,19.7-5.22,29.86-5.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.9,215.29c2.07,1.84,4.09,3.79,6.02,5.8,6.77-1.57,13.84-2.36,20.83-2.36v-7.08c-9.17,0-18.16,1.22-26.84,3.65Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default __webpack_public_path__ + "static/media/sandbox.8fbc4e829a065b1cc17f88511d1faf48.svg";
export { ForwardRef as ReactComponent };